export const LupaLinkkiTyyppi = {
  ALILUPA: "aliluvat",
  PAALUPA: "paaluvat"
};
